export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-mail-send-line text-primary-400 mr-2"></i>
            联系我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500">欢迎投稿爆料或商务合作，你的每一条线索都可能成为明天的头条</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Info cards */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: 'ri-mail-line', title: '投稿爆料', desc: '将你的黑料线索发送给我们，核实后发布并标注来源', action: 'tips@91heilia.com' },
              { icon: 'ri-hand-heart-line', title: '商务合作', desc: '广告投放、品牌合作、内容共创等商务洽谈', action: 'biz@91heilia.com' },
              { icon: 'ri-shield-check-line', title: '侵权申诉', desc: '如认为内容侵权，请提供证明材料联系我们处理', action: 'legal@91heilia.com' },
            ].map((item, i) => (
              <div
                key={i}
                className="p-5 rounded-xl bg-background-800/30 border border-background-800/50 hover:border-primary-500/15 transition-all duration-200"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 mb-4">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-200 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
                <span className="text-xs text-accent-400 font-medium">{item.action}</span>
              </div>
            ))}
          </div>

          {/* Form appearance */}
          <div className="lg:col-span-2 p-6 rounded-xl bg-background-800/20 border border-background-800/50">
            <h3 className="font-heading text-base font-semibold text-foreground-200 mb-4">快速留言</h3>
            <div className="space-y-3">
              <div className="w-full px-4 py-3 rounded-lg bg-background-800/50 border border-background-700/50 text-sm text-foreground-500">
                你的昵称
              </div>
              <div className="w-full px-4 py-3 rounded-lg bg-background-800/50 border border-background-700/50 text-sm text-foreground-500">
                邮箱地址
              </div>
              <div className="w-full px-4 py-3 rounded-lg bg-background-800/50 border border-background-700/50 text-sm text-foreground-500 h-28">
                留言内容...
              </div>
              <button className="w-full px-6 py-3 rounded-lg bg-primary-500/20 border border-primary-500/30 text-primary-400 font-medium text-sm hover:bg-primary-500/30 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-send-plane-line mr-2"></i>发送留言
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}